import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import omit from 'lodash/omit';
import { FormCheck } from '@cancercentrum/rcc-bootstrap';
import { useRegvarValidator } from '../hooks/useRegvarValidator';
const RegvarBoolean = (props)=>{
    const { inputRef, value, disabled, readOnly, ...rest } = props;
    const val = useRegvarValidator();
    const onChange = (e)=>{
        const checked = e.target.checked;
        props.onChange(checked);
    };
    const d = disabled || readOnly || false;
    return /*#__PURE__*/ _jsx(FormCheck, {
        ...omit(rest, 'regvarMetadata', ...val.getValidationPropNames([
            'required'
        ])),
        ref: inputRef,
        type: 'checkbox',
        checked: !!value,
        onChange: onChange,
        disabled: d
    });
};
export default /*#__PURE__*/ memo(RegvarBoolean);
